<template>
	<report-page
		v-if="products.length > 0"
		:start-date="true"
		:end-date="true"
		:products="products"
		radio-title="Select which claims"
		:radio-options="claimOptions"
		get-url="/bo/report/returnrepair/repairdata"
		title="Claims Repair Details"
		export-filename="claimdetails"
	/>
</template>

<script>
import {
	axios,
} from '../../../../../../services/axios-service.js';

export default {
	name: 'ClaimsRepairDetailsExport',

	data () {
		return {
			products: [],
			claimOptions: [
				{
					label: 'All claims', value: 'all'
				},
				{
					label: 'Claims with end status', value: 'settled'
				},
				{
					label: 'Claims without end status', value: 'nonsettled'
				},
			]
		};
	},

	created () {
		axios.get('/api/v0/products/available').then(({
			data: data
		}) => {
			this.products = data.map((product) => {
				return {
					id: product.id,
					name: `${product.name} - ${product.domain}`
				};
			});
		});
	},
};
</script>

